import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=60243c51"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60243c51')) {
      api.createRecord('60243c51', component.options)
    } else {
      api.reload('60243c51', component.options)
    }
    module.hot.accept("./Block.vue?vue&type=template&id=60243c51", function () {
      api.rerender('60243c51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Placeholder/Block.vue"
export default component.exports